import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Grid, MenuItem, Select, Typography, FormControl, InputLabel, TextField, Autocomplete ,Box} from "@mui/material";
import { Button } from "react-bootstrap";
import { useGetMonitorChapterShareMutation, useLazyGetAllChaptersQuery } from "../../app/services/chapterServices";

const MonitorChapterShare = () => {
    const [chaptermonitor] = useGetMonitorChapterShareMutation()
    const [getallChapter] = useLazyGetAllChaptersQuery();
    const [Chapters, setChapters] = useState([]);


    const {
        control,
        watch,
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            chapterId: '',
            fromYear: '',
            fromMonth: '',
            toYear: '',
            toMonth: ''
        },
    });


    useEffect(() => {
        getallChapter().then((res) => {
            if (res?.data?.data) {
                setChapters(res?.data?.data || [])
            }
            else {
                setChapters([])
            }
        })
    }, [setChapters, getallChapter])

    // Month key-value pairs
    const months = [
        {
            id: 1,
            value: "January"
        },
        {
            id: 2,
            value: "February"
        },
        {
            id: 3,
            value: "March"
        },
        {
            id: 4,
            value: "April"
        }
        , {
            id: 5,
            value: "May"
        },
        {
            id: 6,
            value: "June"
        },
        {
            id: 7,
            value: "July"
        },
        {
            id: 8,
            value: "August"
        },
        {
            id: 9,
            value: "September"
        },
        {
            id: 10,
            value: "October"
        },
        {
            id: 11,
            value: "November"
        },
        {
            id: 12,
            value: 'December'
        }];

    const monitorshare = (data) => {
        chaptermonitor(data).then((res) => {
            if (res?.data?.data) {
            }
            else {

            }
        })


    };

    return (
        <>
            <Box>
                {/* <TopHeader /> */}
                <div className="pt-5 mb-4">
                    <div className="chapter-heading">
              <h2 className="text-center title-font text-light py-3 mt-1">Financial Report Of Chapter's Share</h2>
                    </div>
                </div>
            </Box>
            <div className="p-3 p-md-5 overallpadding">
                <form onSubmit={handleSubmit(monitorshare)} className="mt-3 p-3">
                    <Grid container rowSpacing={3} columnSpacing={3} className="d-flex justify-content-start">
                        <Grid item xs={4}>
                            <Controller
                                control={control}
                                name="chapterId"
                                rules={{ required: "Please select a chapter" }} // Validation rule
                                render={({ field, fieldState }) => (
                                    <Autocomplete
                                        id="chapterId"
                                        fullWidth
                                        options={Chapters}
                                        disableCloseOnSelect={false} // Ensures dropdown closes on selection
                                        getOptionLabel={(chapter) => chapter?.title}
                                        isOptionEqualToValue={(option, value) => option._id === value._id} // Fixes deprecation of getOptionSelected
                                        onChange={(event, value) => {
                                            field.onChange(value?._id); // Store single _id instead of array
                                        }}
                                        value={Chapters.find((group) => group._id === field.value) || null} // Ensure it finds the correct object
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                error={!!fieldState?.error}
                                                helperText={fieldState?.error?.message}
                                                variant="outlined"
                                                label={
                                                    <Typography className="text-dark w-100 d-inline-block overflow-hidden text-nowrap"
                                                        style={{ textOverflow: "ellipsis" }}>
                                                        Chapter Name{" "}
                                                        <span style={{ color: "red" }}>*</span>
                                                    </Typography>
                                                }
                                                placeholder={watch('chapterId') ? '' : "Select Chapter Name"}
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>

                        {/* From Month */}
                        <Grid item xs={12} md={6} lg={4}>
                            <Controller
                                control={control}
                                name="fromMonth"
                                rules={{ required: "Please select a month" }} // Validation rule
                                render={({ field, fieldState }) => (
                                    <FormControl fullWidth error={!!fieldState.error}>
                                        <InputLabel id="fromMonth-label" className="text-dark">
                                            From Month <span style={{ color: "red" }}>*</span>
                                        </InputLabel>
                                        <Select
                                            {...field} // Pass field props correctly
                                            label={
                                                <Typography className="text-dark">
                                                    From Month
                                                    <span style={{ color: "red" }}>*</span>
                                                </Typography>
                                            } id="fromMonth"
                                            value={field.value || ""} // Ensure value is controlled
                                            onChange={(e) => field.onChange(e.target.value)} // Handle change correctly
                                        >
                                            <MenuItem value="">Select Month</MenuItem>
                                            {months.map((data) => (
                                                <MenuItem key={data.id} value={data.value}>
                                                    {data.value}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {fieldState.error && (
                                            <Typography variant="body2" color="error">
                                                {fieldState.error.message}
                                            </Typography>
                                        )}
                                    </FormControl>
                                )}
                            />
                        </Grid>

                        {/* From Year */}
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                label={
                                    <Typography className="text-dark">
                                        From Year<span style={{ color: "red" }}>*</span>
                                    </Typography>
                                }

                                {...register("fromYear", {
                                    required: "Please enter a from year  ",
                                    pattern: {
                                        value: /^\d{4}$/,
                                        message: "Please enter a valid year",
                                    },
                                    max: {
                                        value: new Date().getFullYear(),
                                        message: "Future year is not allowed",
                                    },
                                })}
                                error={!!errors?.fromYear}
                                helperText={errors?.fromYear?.message}
                                placeholder="YYYY "
                            />
                        </Grid>
                        {/* To month */}
                        <Grid item xs={12} md={6} lg={4}>
                            <Controller
                                control={control}
                                name="toMonth"
                                rules={{ required: "Please select a month" }} // Validation rule
                                render={({ field, fieldState }) => (
                                    <FormControl fullWidth error={!!fieldState.error}>
                                        <InputLabel id="toMonth-label" className="text-dark">
                                            To Month <span style={{ color: "red" }}>*</span>
                                        </InputLabel>
                                        <Select
                                            {...field} // Properly bind field props
                                            labelId="toMonth-label"
                                            label={
                                                <Typography className="text-dark">
                                                    To Month
                                                    <span style={{ color: "red" }}>*</span>
                                                </Typography>
                                            } value={field.value || ""} // Ensure value is controlled
                                            onChange={(e) => field.onChange(e.target.value)} // Handle change correctly
                                        >
                                            <MenuItem value="">Select Month</MenuItem>
                                            {months.map((data) => (
                                                <MenuItem key={data.id} value={data.value}>
                                                    {data.value}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {fieldState.error && (
                                            <Typography variant="body2" color="error">
                                                {fieldState.error.message}
                                            </Typography>
                                        )}
                                    </FormControl>
                                )}
                            />
                        </Grid>

                        {/* To year */}
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                label={
                                    <Typography className="text-dark">
                                        To Year<span style={{ color: "red" }}>*</span>
                                    </Typography>
                                }

                                {...register("toYear", {
                                    required: "Please enter a to year  ",
                                    pattern: {
                                        value: /^\d{4}$/,
                                        message: "Please enter a valid year",
                                    },
                                    max: {
                                        value: new Date().getFullYear(),
                                        message: "Future year is not allowed",
                                    },
                                })}
                                error={!!errors?.toYear}
                                helperText={errors?.toYear?.message}
                                placeholder="YYYY "
                            />
                        </Grid>



                    </Grid>
                    <div className="d-flex justify-content-center mt-3">
                        <Button
                            variant="contained"
                            className="menus-color"
                            type="submit"
                        >
                            Generate
                        </Button>
                    </div>
                </form>
            </div >
        </>
    );
};

export default MonitorChapterShare;
